<template>
  <div class="parent" :class="{'player-minimised':minimised}" :style="`--player-border-color:${settings.borderColor}`">
      <figure class="figure-tag" ref="figureTag" :class="{'no-cursor':!userActive}">
        <!--keep video tag as top component to avoid rerenders. -->  
        <div class="video-wrapper" @touchend='userTouch' @click="userClick">
            <video src="" class="video-tag" ref='videoTag' crossorigin tabindex="0"></video>
        </div>  
        
        <!-- player close button -->
        <div class="player-closer" 
            v-show="loading || userActive">
            <button type="button" @click="closer" class="close-button">
                <img src="@video/src/assets/close.svg" alt="close player">
            </button>
        </div>         
     
        <!-- player close button -->

         <!-- poster image-->
        <div class="poster-wrapper" v-if="settings.posterActive && showPoster && playerContent.getPoster()">
            <img :src="playerContent.getPoster()" class="poster-image">
        </div>
        <!-- poster image-->

        <!-- title component<optional>: no defaults app-specific: show content details-->
        <component
                class="player-title"
                :is="components.title"
                v-if="components.title && playerLoaded" 
                v-show="userActive"         
                :content="currentContent"
        />
        <!-- player content description-->

        <!-- errorModal component<optional> no defaults app-specific: component as popup to show any errors.-->
        <component class="error-modal" 
        v-if="components.errorModal && error" 
        :is="components.errorModal" 
        :error="error"
        :content="currentContent"
        />  
        <!-- errorModal component<optional>:-->

        <!-- expand icon in minimised view -->    
        <div class="expand-wrapper">
            <img :src="require('@video/src/assets/expander.svg')" 
            alt="expander" 
            class="m-icon" 
            @click="toggleMinimise(false)"
            v-if="playerLoaded"
            />
        </div> 
        <!-- expand icon in minimised view -->     
       
        
        <div class="center-wrapper" @touchend='userTouch' @click="userClick">
            <middle-man
                :components="components"
                :icons="icons"
                :loading="loading"
                :userActive="userActive"
                :player="player"
                :contentPlaying="contentPlaying"
                :playerLoaded="playerLoaded"
                :ended="ended"
                
            />
        </div>
       <!-- interval component-->
        <component
            :is="components.interval"
            v-if="playerLoaded && showInterval"
            :loadContent="loadContent"
            :currentContentId="playerContent.contentId"
            :playlist="playlist"
            :intervalToggle="intervalToggle"
            :borderColor="settings.borderColor"
            class="interval-wrapper"
        />
       <!-- interval component-->

        <!-- settings component-->
        <component
            :is="components.settings"
            :player="player"
            :settingsToggle="settingsToggle"
            :videoSettings="videoSettings"
            v-if="playerLoaded && ( Object.keys(videoSettings).length>0 )" 
            v-show="userActive && showSettings"
            class="settings-wrapper"
        />
        <!-- settings component-->

        <!-- playlist component-->
        <component 
            :is="components.playlist"
            :playlist="playlist"
            :currentContentId="playerContent.contentId"
            :loadContent="loadContent"
            :playlistToggle="playlistToggle"
            :playlistActive="userActive && showPlaylist"
            v-if="playerLoaded" 
            v-show="userActive && showPlaylist"
            class="playlist-wrapper"
        />
        <!-- playlist component-->

        <!-- control_bar component -->
        <component :is="components.control_bar"
        v-if='playerLoaded'
        v-show="userActive" 
        :currentTime="currentTime"
        :contentDuration="contentDuration"
        :videoController="player.videoController"
        :bufferedRange="bufferedRange"
        :fsToggle="fsToggle"
        :fsActive="fsActive"
        :playlistToggle="playlistToggle"
        :settingsToggle="settingsToggle"
        :settings="settings"
        :toggleMinimise="toggleMinimise"
        :contentPlaying="contentPlaying"
        :live="playerContent && playerContent.live"
        :ended="ended"
        :settingsAvailable="( Object.keys(videoSettings).length>0 )"
        class="control-wrapper"
            />
        <!-- control_bar component --> 

        <component
        v-if="playerLoaded"
        :is="components.subtitles"
        :userActive="userActive"
        :cueTexts="cueTexts"
         />   

        <!-- fingerprint ID -->
        <div class="fp_id" v-if="fp_position && settings.fingerPrintData" :style="fp_position">{{`${settings.fingerPrintData}:${playerContent && playerContent.token}`}}</div> 
         <!-- fingerprint ID -->

         <!-- product-logo -->
         <div class="product-logo" v-if="settings.productLogo">
             <img :src="settings.productLogo" alt="logo">
         </div>
         <!-- product-logo -->
      </figure>
  </div>
</template>

<script>
import Promiser from '@video/src/utils/promiser.js';
import MiddleMan from '@video/src/components/Middleman.vue';
export default {
    props:{
      customComponents:{ //custom components imports to be merged.
          type:Object,
          default(){
              return {};
          }
      },
      customIcons:{
          type:Object,
          default(){
              return {}
          }
      },
      customSettings:{ //component settings.
          type:Object,
          default(){
              return {}
          }
      },
      player:{ //instance of player.
          type:Object,
          required:true
      },
      getItem:{ //factory function for playlist item creation.
          type:Function,
          required:true
      },
      playlist:{
          type:Array,
          required:true
      },
      closer:{
          type:Function,
          default(){
              return ()=>{};
          }
      }
    },
    data(){
        return {
            components:{
                control_bar:()=>import('@video/src/components/controls/ControlBar.vue'),
                playpauser:()=>import('@video/src/components/playpause/Playpauser.vue'),
                playlist:()=>import('@video/src/components/playlist/Playlist.vue'),
                settings:()=>import('@video/src/components/settings/Settings.vue'),
                interval:()=>import('@video/src/components/interval/Interval.vue'),
                subtitles:()=>import('@video/src/components/subtitles/Subtitles.vue')
            },
            icons:{
                play:'play.svg',
                replay:'replay.svg',
                pause:'pause.svg',
                forward:'forward.svg',
                rewind:'rewind.svg',
            },
            settings:{
                startIndex:0,
                autoPlay:false,
                playlistActive:false,
                posterActive:false,
                idleHideDuration:2000,
                borderColor:'red',
                fingerPrintData:null,
                productLogo:null,
                slidebar:{
                   progressColor:'orange',
                   pointerColor:'red'
                }
            },
            playerLoaded:false, //fired true when first content loaded.
            playerContent:null, //current playerContent
            currentTime:0,  //current video-running time in seconds.
            contentPlaying:false, //play-pause reference.
            contentDuration:0,
            loading:false,
            bufferedRange:[0,0], //latest buffered range.
            userActive:false, //user active - show controls.
            controlsTimerId:null,
            fsActive:false,
            videoSettings:{},
            minimised:false,
            error:null,
            secondsPlayed:0,
            showSettings:false,
            showPlaylist:false,
            showInterval:false,
            showPoster:false,
            screenIntersectors:['showPlaylist','showSettings','showInterval'],
            ended:false,
            fp_position:null,
            fp_interval:null,
            hoverAvailable:(window.matchMedia?.('(any-hover:hover)')?.matches),
            cueTexts:[]
        }
    },
    computed:{
        currentContent(){
           return this.playlist.find(content=>content.contentId===this.playerContent?.contentId);
        }
    },
    watch:{
        userActive(newvalue){
            this.$emit('userActive',newvalue);
        },
        minimised(newvalue){
            this.$emit('minimised',newvalue)
        }
    },
    methods:{
        instantiatePlayer(){
            let videoTag = this.$refs.videoTag;
            if(!videoTag)return console.warn('no videoTag found');
            this.player.instantiate(videoTag);
            this.attachVideoEvents();
            this.loadContent(this.playlist[this.settings.startIndex??0]).then((res)=>{  
                if(!res.loaded)return;//ensure player is loaded properly.
                this.playerLoaded=true;
                window.player=this.player;
                this.$nextTick(()=>{
                    //emit playerloaded to create rest of playlist and other activities.
                    this.$emit('playerloaded',res.content);
                })
            });
        },
        async loadContent(content){ 
            Promiser.reject( 'load-content', { errorDispatched: true } ); 
            this.intervalToggle(false);    
            const previousContent=!this.ended && this.currentContent; //avoid multiple emits.
            if(previousContent){
                previousContent.position=this.currentTime;
                previousContent.duration=this.contentDuration;
            }
            try{
                if(content)this.playerContent=await Promiser( 'load-content' , this.getItem(content) ); 

                if( !this.playerContent.getSource() ) {
                    await this.player.unloadContent();
                    throw ( { errorDispatched: true } );
                }

                this.showPoster=true;

                this.videoSettings={};
                
                await Promiser( 'load-content' , this.player.loadContent(this.playerContent) );

                if( this.playerContent.position && 
                    (( this.player.videoController.duration - this.playerContent.position)>this.playerContent.toEndSeconds)
                ){
                    await Promiser( 'load-content', this.player.videoController.seekTrack(this.playerContent.position) );
                }

                if(this.settings.autoPlay)await Promiser( 'load-content', this.player.videoController.play() ); 

                this.showPoster=false;
                this.ended=false;
                
                this.processLoadEmits(previousContent,content);

                Promiser.clear( 'load-content' );
                return {loaded:true,content}
            }
            catch(err){
                console.warn(err);
                if( !err?.errorDispatched ) this.player.hub.dispatch('error',err);
                return {loaded:false}
            }

        },
        processLoadEmits(unloadContent,loadContent){
            if(unloadContent){
                    unloadContent.secondsPlayed=this.secondsPlayed;
                    this.player.hub.dispatch('content-unload',{
                        content:unloadContent
                    });
                this.secondsPlayed=0;    
            }
            if(loadContent)this.player.hub.dispatch('content-load',{content:loadContent});
        },
        getRandomized(length){
            length=Number(length);
            let randomval=Math.random();
            return length && !isNaN(length)?Math.floor(randomval*(Math.pow(10,length))):randomval;
        },   
         runFingerPrint(){
            this.fp_interval=setInterval(()=>{
                if(!this.contentPlaying)return;
                //get random 2 digits for positioning.
                let positions=[this.getRandomized(2),this.getRandomized(2)];
                let [left,top]=positions.map(val=>val+'%');
                //set translate to avoid positioning outside visual area.
                let translate=positions.map(dir=> (dir>50?-100:100) + '%').join(',');  
                this.fp_position={top,left,transform:`translate(${translate})`};

                this.$nextTick(()=>{
                    setTimeout(()=>{
                        this.fp_position=null;
                    },30)
                });
       
            },5000)
        },
        attachVideoEvents(){
                this.player.videoController.setVolume(1);
                this.player.videoController.hub.listen('loadstart',()=>{
                    this.toggleVideoPlaying(false);
                    this.toggleLoader(true);
                });
                this.player.videoController.hub.listen('loadedmetadata',this.setDuration);
                this.player.videoController.hub.listen('timeupdate',this.setCurrentPosition);
                this.player.videoController.hub.listen('ended',this.setContentEnded);
                this.player.videoController.hub.listen('loadeddata',()=>this.toggleLoader(false));
                this.player.videoController.hub.listen('seeking',()=>this.toggleLoader(true));
                this.player.videoController.hub.listen('seeked',this.handleSeekingEnd);
                this.player.videoController.hub.listen('play',()=>{
                    this.toggleVideoPlaying(true);
                    if(this.ended)this.ended=false;
                });
                this.player.videoController.hub.listen('pause',()=>this.toggleVideoPlaying(false));
                this.player.videoController.hub.listen('progress',this.updateBuffer);
                this.player.videoController.hub.listen('cue-change-texts',(texts)=>{
                    this.cueTexts=texts;
                })
        },
        toggleLoader(val){
            if(typeof(val) === 'boolean')this.loading=val;
        },
        setDuration(event){
            this.contentDuration = parseInt(event.target.duration, 10);
        },
        setCurrentPosition(event){
            if (this.seekInProgress)return; 
            let currentTime = parseInt(event.target.currentTime, 10);
            if(this.currentTime === currentTime)return;
            this.currentTime=currentTime;
            if(this.contentPlaying)this.secondsPlayed++;
        },  
        handleSeekingEnd(event) {
            this.setCurrentPosition(event);
            this.toggleLoader(false); 
        },
        toggleVideoPlaying(val){
            if(typeof(val) === 'boolean')this.contentPlaying=val;
        },
        playPause(){
            this.contentPlaying?this.player.videoController.pause():this.player.videoController.play();
        },
        userClick(){
            this.hoverAvailable && this.playPause();
        },
        userTouch(){
            if(this.hoverAvailable)return;

            this.userActive && this.playPause();       
            this.showControls();
        },
        updateBuffer(event){
            let buffered=event.target?.buffered;
            if(!buffered || !buffered.length)return;
            let index=buffered.length-1;
            this.bufferedRange=[buffered.start(index),buffered.end(index)];
        },
        setContentEnded(e){
            console.log('content ended',e);
            this.ended=true;
            if(this.currentContent){
                this.currentContent.position=this.currentTime;
                this.currentContent.duration=this.contentDuration;
                this.processLoadEmits(this.currentContent);
            }  
            this.intervalToggle(true);
        },
        showControls(){
            this.userActive=true;
            window.clearTimeout(this.controlsTimerId);    
            this.controlsTimerId=setTimeout(()=>{
                if(!this.showPlaylist && !this.showSettings){
                    this.userActive=false;
                }
            },this.settings.idleHideDuration)
        },
        handleKeyControl(e){
            const code=e.code;
            if(e.target.tagName==='BUTTON')return; //avoid default button activity override.
            switch(code){
                case 'Space':
                case 'Enter':    
                    this.playPause();
                    break;
                case 'ArrowLeft':
                    this.player.videoController.backwards();
                    break;
                case 'ArrowRight':
                    this.player.videoController.forwards();
                    break;
                case 'ArrowUp':
                    this.player.videoController.setVolume(vol=>vol+0.1);
                    break;
                case 'ArrowDown':
                    this.player.videoController.setVolume(vol=>vol-0.1);
            }
        },
        async fsToggle(){
            if(!this.fsActive){
                let figure=this.$refs?.figureTag;
                if(!figure)return;
                await figure.requestFullscreen();
                this.fsActive=true;
            }
            else {
                await document.exitFullscreen();
                this.fsActive=false;
            }
        },
        fsChanged(){
            if(document.fullscreenElement)this.fsActive=true;
            else this.fsActive=false;
        },
        playlistToggle(val){
            this._valueToggler('showPlaylist',val);
        },
        settingsToggle(val){
            this._valueToggler('showSettings',val);
        },
        intervalToggle(val){
            this._valueToggler('showInterval',val);
        },
        _valueToggler(prop,value){
            if(typeof(value)==='boolean')this[prop]=value;

            else this[prop]=!this[prop];

            if(this[prop]){
                this.screenIntersectors.forEach(key=>{
                    if(key!==prop)this[key]=false;
                })
            }
        },
        toggleMinimise(val=false){
            this.minimised=val;
        },
        attachEvents(){
            document.addEventListener('mousemove',this.showControls);
            document.addEventListener('mousedown',this.showControls);
            document.addEventListener('touchmove',this.showControls);
            document.addEventListener('touchend',this.showControls);
            document.addEventListener('fullscreenchange',this.fsChanged);
            document.addEventListener('keydown',this.handleKeyControl)
        },
        updateVideoSettings(type,list=[]){
            if(list?.length)this.videoSettings[type]=[...list];
        },
        addPlayerListeners(){
            this.player.hub.listen('subtitleList',(list)=>{this.updateVideoSettings('subtitle',list)});
            this.player.hub.listen('qualityList',(list)=>{this.updateVideoSettings('quality',list)});
            this.player.hub.listen('audioList',(list)=>{this.updateVideoSettings('audio',list)});
        },
        mergeCustomRequirements(){
            this.components={...this.components,...this.customComponents}; //merge custom components.
            this.icons={...this.icons,...this.customIcons};//merge custom icons.
            this.settings={...this.settings,...this.customSettings} //merge custom settings.
        },
        handleErrors(){
            this.player.hub.listen('error',(err)=>{
                 this.error=err;   
            })
        }
    },
    created(){
        this.handleErrors();
        this.mergeCustomRequirements();
        this.addPlayerListeners();
    },
    beforeDestroy(){
        if(this.currentContent){
            this.currentContent.position=this.currentTime;
            this.currentContent.duration=this.contentDuration;
            this.processLoadEmits(this.currentContent);
        }
        this.player.destroy();
        document.removeEventListener('mousemove',this.showControls);
        document.removeEventListener('mousedown',this.showControls);
        document.removeEventListener('touchmove',this.showControls);
        document.removeEventListener('touchend',this.showControls);
        document.removeEventListener('fullscreenchange',this.fsChanged);
        document.removeEventListener('keydown',this.handleKeyControl);
        window.clearInterval(this.fp_interval);
    },
    components:{
        MiddleMan
    },
    mounted(){
        this.$refs.videoTag.focus();
        this.instantiatePlayer();
        this.attachEvents();
        if(this.settings.fingerPrintData)this.runFingerPrint();
    }
}
</script>
<style lang="scss">
@import '@video/src/scss/_rootVariables.scss';
</style>
<style lang='scss' scoped>
@import '@video/src/scss/_mixins.scss';
@import '@video/src/scss/_variables.scss';
.contain{
    height:100%;
    width:100%;
}

.parent{//customizable according to requirement...defaults to full screen.
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width:100%;
        height:100vh;//override to 100% for better mobile view.
        overflow:hidden;
        transition:height 0.2s, width 0.2s;
        .figure-tag{
            margin:0 !important;
            @extend .contain;
            position:relative;
            background:black;
            &.no-cursor{
                cursor:none;
            }
            
                
            .player-closer{
                position:absolute;
                top:$top-margin;
                right:$side-margin;
                height:$closer-height;
                margin-left:auto;
                z-index: 3;
                .close-button{
                    @include flex($justify:flex-end);
                    height:100%;
                    outline:none;
                    background:none;
                    border:none;
                    cursor: pointer;
                    img{
                        @include hovereffects;
                        display: block;
                        height:100%;
                    }
                }
            }
               
            .error-modal{
                position:absolute;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                z-index:4;   
            } 
            .expand-wrapper{
                position:absolute;
                z-index:3;
                top:$top-margin;
                left:calc( ( 100% - #{$controls-width} ) / 2 );
                width:30px;
                display:none;
                .m-icon{
                    display:block;
                    cursor: pointer;
                    @include hovereffects;
                }
            }

            .poster-wrapper{
                position:absolute;
                top:0;
                left:0;
                @extend .contain;
                .poster-image{
                    display:block;
                    @extend .contain;
                    object-fit: contain;
                }
            }
            .video-wrapper{
                @extend .contain;
                .video-tag{
                    @extend .contain;
                    object-fit: contain;
                }
            }
            .center-wrapper{
                @include flex;
                position:absolute;
                height:50%;
                width:100%;
                left:50%;
                top:50%;
                transform:translate(-50%,-50%);
            }

            .fp_id{
                position:absolute;
                transform:translate(-50%,-50%);
                z-index: 100;
                font-family: sans-serif;
                font-size:10px;
                color:rgba(255, 255, 255, 0.85) ;
                text-shadow:0 0 3px black;
                opacity:0.1;
            }

            .product-logo{
                position:absolute;
                top:calc( #{$top-margin} + #{$closer-height} );
                right:$side-margin;
                height:10%;
                margin-top:10px;
                img{
                    display:block;
                    height:100%;
                }
            }
        }

       &.player-minimised{
           position:fixed !important;
           bottom:0 !important;
           right:0 !important;
           width:400px !important;
           height:225px !important;
           .expand-wrapper{
                display:block !important;
            }
           .player-title,
           .settings-wrapper,
           .playlist-wrapper,
           .interval-wrapper{
               display:none !important;
           } 
          
       } 
    }
</style>